import { getConfig } from '@local/app-config';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query/react';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { getCombinedToken as getAccessToken } from '../../store/sessionStorageHelpers/accessTokenHelper/accessTokenHelper';

// We fetch this at run time to make testing easier, we can override the env values.
const dynamicBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    args,
    WebApi,
    extraOptions,
) => {
    const baseUrl = getConfig().identity_url;
    const rawBaseQuery = fetchBaseQuery({
        baseUrl,
        prepareHeaders: (headers) => {
            const token = getAccessToken()?.access_token;
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    });
    return rawBaseQuery(args, WebApi, extraOptions);
};

export const UserApiClient = createApi({
    reducerPath: 'userApi',
    baseQuery: dynamicBaseQuery,
    endpoints: () => ({}),
});
